// Icons are single SVGs from the remixicon package, inlined at build time, so
// only the ones the app uses ship (the icon font would ship all of them).
// To add one: import its SVG ?raw and add it to `icons`.
import add from "remixicon/icons/System/add-line.svg?raw";
import album from "remixicon/icons/Media/album-line.svg?raw";
import arrowDown from "remixicon/icons/Arrows/arrow-down-s-line.svg?raw";
import arrowLeft from "remixicon/icons/Arrows/arrow-left-line.svg?raw";
import arrowRight from "remixicon/icons/Arrows/arrow-right-line.svg?raw";
import arrowUp from "remixicon/icons/Arrows/arrow-up-s-line.svg?raw";
import barChart from "remixicon/icons/Business/bar-chart-line.svg?raw";
import check from "remixicon/icons/System/check-line.svg?raw";
import checkboxCircle from "remixicon/icons/System/checkbox-circle-line.svg?raw";
import close from "remixicon/icons/System/close-line.svg?raw";
import closeCircle from "remixicon/icons/System/close-circle-line.svg?raw";
import coin from "remixicon/icons/Finance/coin-line.svg?raw";
import coins from "remixicon/icons/Finance/coins-line.svg?raw";
import customerService from "remixicon/icons/Business/customer-service-2-line.svg?raw";
import deleteBin from "remixicon/icons/System/delete-bin-line.svg?raw";
import disc from "remixicon/icons/Media/disc-line.svg?raw";
import equalizer from "remixicon/icons/Media/equalizer-line.svg?raw";
import errorWarning from "remixicon/icons/System/error-warning-line.svg?raw";
import externalLink from "remixicon/icons/System/external-link-line.svg?raw";
import eye from "remixicon/icons/System/eye-line.svg?raw";
import eyeOff from "remixicon/icons/System/eye-off-line.svg?raw";
import feedback from "remixicon/icons/Communication/feedback-line.svg?raw";
import fileCopy from "remixicon/icons/Document/file-copy-line.svg?raw";
import filter from "remixicon/icons/System/filter-3-line.svg?raw";
import global from "remixicon/icons/Business/global-line.svg?raw";
import google from "remixicon/icons/Logos/google-fill.svg?raw";
import handCoin from "remixicon/icons/Finance/hand-coin-line.svg?raw";
import handHeart from "remixicon/icons/Finance/hand-heart-line.svg?raw";
import headphone from "remixicon/icons/Media/headphone-line.svg?raw";
import homeHeart from "remixicon/icons/Buildings/home-heart-line.svg?raw";
import homeSite from "remixicon/icons/Buildings/home-4-line.svg?raw";
import image from "remixicon/icons/Media/image-line.svg?raw";
import inbox from "remixicon/icons/Business/inbox-line.svg?raw";
import inboxArchive from "remixicon/icons/Business/inbox-archive-line.svg?raw";
import instagram from "remixicon/icons/Logos/instagram-line.svg?raw";
import info from "remixicon/icons/System/information-line.svg?raw";
import key from "remixicon/icons/Others/key-2-line.svg?raw";
import layout from "remixicon/icons/Design/layout-line.svg?raw";
import lineChart from "remixicon/icons/Business/line-chart-line.svg?raw";
import link from "remixicon/icons/Editor/link.svg?raw";
import links from "remixicon/icons/Business/links-line.svg?raw";
import lock from "remixicon/icons/System/lock-line.svg?raw";
import lockPassword from "remixicon/icons/System/lock-password-line.svg?raw";
import mail from "remixicon/icons/Business/mail-line.svg?raw";
import mailOpen from "remixicon/icons/Business/mail-open-line.svg?raw";
import mapPin from "remixicon/icons/Map/map-pin-line.svg?raw";
import megaphone from "remixicon/icons/Business/megaphone-line.svg?raw";
import menu from "remixicon/icons/System/menu-line.svg?raw";
import moneyDollar from "remixicon/icons/Finance/money-dollar-circle-line.svg?raw";
import music from "remixicon/icons/Media/music-2-line.svg?raw";
import notification from "remixicon/icons/Media/notification-3-line.svg?raw";
import paypal from "remixicon/icons/Logos/paypal-line.svg?raw";
import play from "remixicon/icons/Media/play-fill.svg?raw";
import question from "remixicon/icons/System/question-line.svg?raw";
import quillPen from "remixicon/icons/Design/quill-pen-line.svg?raw";
import refresh from "remixicon/icons/System/refresh-line.svg?raw";
import refund from "remixicon/icons/Finance/refund-2-line.svg?raw";
import rocket from "remixicon/icons/Map/rocket-line.svg?raw";
import searchEye from "remixicon/icons/System/search-eye-line.svg?raw";
import share from "remixicon/icons/System/share-forward-line.svg?raw";
import shieldCheck from "remixicon/icons/System/shield-check-line.svg?raw";
import shoppingCart from "remixicon/icons/Finance/shopping-cart-line.svg?raw";
import smartphone from "remixicon/icons/Device/smartphone-line.svg?raw";
import soundcloud from "remixicon/icons/Logos/soundcloud-line.svg?raw";
import star from "remixicon/icons/System/star-fill.svg?raw";
import starLine from "remixicon/icons/System/star-line.svg?raw";
import store from "remixicon/icons/Buildings/store-2-line.svg?raw";
import team from "remixicon/icons/User & Faces/team-line.svg?raw";
import time from "remixicon/icons/System/time-line.svg?raw";
import trophy from "remixicon/icons/Finance/trophy-line.svg?raw";
import twitterX from "remixicon/icons/Logos/twitter-x-line.svg?raw";
import upload from "remixicon/icons/System/upload-2-line.svg?raw";
import uploadCloud from "remixicon/icons/System/upload-cloud-2-line.svg?raw";
import user from "remixicon/icons/User & Faces/user-line.svg?raw";
import user3 from "remixicon/icons/User & Faces/user-3-line.svg?raw";
import userAdd from "remixicon/icons/User & Faces/user-add-line.svg?raw";
import userHeart from "remixicon/icons/User & Faces/user-heart-line.svg?raw";
import userSettings from "remixicon/icons/User & Faces/user-settings-line.svg?raw";
import userStar from "remixicon/icons/User & Faces/user-star-line.svg?raw";
import userUnfollow from "remixicon/icons/User & Faces/user-unfollow-line.svg?raw";
import video from "remixicon/icons/Media/video-line.svg?raw";
import videoAdd from "remixicon/icons/Media/video-add-line.svg?raw";
import wallet from "remixicon/icons/Finance/wallet-3-line.svg?raw";
const icons = {
  add,
  album,
  arrowDown,
  arrowLeft,
  arrowRight,
  arrowUp,
  barChart,
  check,
  checkboxCircle,
  close,
  closeCircle,
  coin,
  coins,
  customerService,
  deleteBin,
  disc,
  equalizer,
  errorWarning,
  externalLink,
  eye,
  eyeOff,
  feedback,
  fileCopy,
  filter,
  global,
  google,
  handCoin,
  handHeart,
  headphone,
  homeHeart,
  homeSite,
  image,
  inbox,
  inboxArchive,
  info,
  instagram,
  key,
  layout,
  lineChart,
  link,
  links,
  lock,
  lockPassword,
  mail,
  mailOpen,
  mapPin,
  megaphone,
  menu,
  moneyDollar,
  music,
  notification,
  paypal,
  play,
  question,
  quillPen,
  refresh,
  refund,
  rocket,
  searchEye,
  share,
  shieldCheck,
  shoppingCart,
  smartphone,
  soundcloud,
  star,
  starLine,
  store,
  team,
  time,
  trophy,
  twitterX,
  upload,
  uploadCloud,
  user,
  user3,
  userAdd,
  userHeart,
  userSettings,
  userStar,
  userUnfollow,
  video,
  videoAdd,
  wallet,
} as const;

export type IconName = keyof typeof icons;

export default function Icon({ name, className = "" }: { name: IconName; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={`bf-icon inline-flex shrink-0 ${className}`}
      dangerouslySetInnerHTML={{ __html: icons[name] }}
    />
  );
}
